import { Sites } from '@ps/platform-message-framework/common/Sites';
import { FeatureFlag } from '@ps/web-core-enums';
import { select, useFeature } from '@ps/web-core-store';
import { useSelector } from 'react-redux';

import useWizardContext from '@swf/core/hooks/useWizardContext';

import { RealMoneyStatus } from '../types/status';

function isOasisCheckSuccessful() {
  const { error } = useWizardContext();
  if (error && error.globalErrors) {
    return error.globalErrors.some((e) => e.code !== RealMoneyStatus.DE_BANNED_BY_REGULATOR);
  }
  return true;
}

const useEkycTransitionScreenCheck = (): boolean => {
  const siteId = useSelector(select.cms.getSiteId);
  const isRetryScreenEnabled = useFeature(FeatureFlag.SwcRetryScreen);

  switch (siteId) {
    case Sites.FRA:
      return isRetryScreenEnabled;
    case Sites.DE:
      return isRetryScreenEnabled && isOasisCheckSuccessful();
    case Sites.UK:
      return isRetryScreenEnabled;
    case Sites.CA_ON:
      return isRetryScreenEnabled;
    default:
      return false;
  }
};

export default useEkycTransitionScreenCheck;
